export default __webpack_public_path__ + "static/media/Blogger.1bc41dad.gif";